import { useEffect, useState, useCallback, useRef } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
//import { GinecologiaRecord } from './GinecologiaRecord';
import Webcam from "react-webcam";
import moment from "moment";
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';


let emp = 0;
const modeloDatos = {
    evaluacionID: 0,
    empresaID: 0,
    cedula: "",

    // Información general
    nombrePaciente: "",
    edad: null,
    sexo: 'M',
    fecha: new Date,
    ocupacion: "",

    // Hábitos alimenticios
    comidasPrincipales: "",
    refrigerios: "",
    desayuno: "",
    almuerzo: "",
    cena: "",
    bocadillos: "",
    tamanoPorciones: "",
    patronPorciones: "",
    aguaDiaria: "",
    bebidas: "",
    alcohol: "",
    comidaFuera: "",
    dietaEspecifica: "",
    alergiasAlimentos: "",
    comidaEmocional: "",
    ritmoComida: "",
    metodosCoccion: "",

    // Historial médico
    condicionesMedicas: "",
    tratamientoMedico: "",
    medicamentos: "",
    suplementos: "",
    historialFamiliar: "",
    cambiosPeso: "",
    cirugias: "",
    problemasDigestivos: "",
    alergiasMedicamentos: "",
    calidadSueno: "",
    problemasSueno: "",

    // Objetivos nutricionales
    objetivoPrincipal: "",
    objetivoCortoPlazo: "",
    objetivoLargoPlazo: "",
    expectativasConsulta: "",
    desafios: "",
    preferenciasAlimenticias: "",

    // Estilo de vida
    actividadFisica: "",
    ejercicioRegular: "",
    apoyoNecesario: "",

    fechaRegistro: new Date,
    telefono: "",
    PesoInicio: ""
}
const modeloRecord = {
    recordPacienteNutricionID: 0,
    empresaID: emp,
    pacienteID: 0,
    historiaClinica: '',
    comentario: '',
    fecha: new Date,
    codigoUnico: '',
    tArterial: '',
    fCardiaca: '',
    fRespiratoria: '',
    temperatura: '',
    saturacionO: '',
    peso: '',
    talla: '',
    imc: ''
}
const modeloReceta = {
    recetaID: 0,
    empresaID: emp,
    pacienteID: 0,
    recordPacienteID: 0,
    medicamentoID: 0,
    nombreMedicamento: '',
    fecha: new Date,
    comentario: '',
    fechaCreado: new Date,
    creadoPor: '',
    dosificacion: '',
    CodigoUnicoRecord: ''
}
let options = [];
let optionsP = [];
let optionsT = [{ descripcion: "" }];

const Ginecologia = () => {
    emp = JSON.parse(localStorage.getItem("sesion_usuario")).empresaID;

    const [tabla, setTabla] = useState(modeloDatos);
    const [tablap, setTablap] = useState(modeloDatos);

    const [tablaRecord, setTablaRecord] = useState(modeloRecord);
    const [tablaReceta, setTablaReceta] = useState(modeloReceta);
    const [Listado, SetListado] = useState([]);
    const [ListadoSeg, SetListadoSeg] = useState([]);
    const [ListadoTox, SetListadoTox] = useState([]);
    const [ListadoRecord, SetListadoRecord] = useState([]);
    const [ListadoReceta, SetListadoReceta] = useState([]);
    const [ListadoMedicamento, SetListaMedicamento] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Listado1, SetListado1] = useState([]);
    const [paciente, Setpaciente] = useState([]);
    const [Camara, SetCamara] = useState(false);
    const [Receta, SetReceta] = useState(false);
    const [Embarazada, SetEmbarazada] = useState(false);
    const [VerEmbarazada, SetVerEmbarazada] = useState(false);

    const [Inicio, SetInicio] = useState(false);


    let correo = JSON.parse(user).correo;
    const onBusqueda = async (e) => {
        var l = Listado1;

        var searchData = l.filter((item) => {
            if (
                (item.nombrePaciente + item.cedula + item.telefono)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())

            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

    const handleChange = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        if (e.target.name == "sexo") {
            icono(e.target.value)
        }
        if (e.target.name == "cedula" && e.target.value.length > 10) {
            ValidarCedula(e.target.value);
        }
        else {
            setTabla({
                ...tabla,
                [e.target.name]: e.target.value
            })
        }
    }
    const handleChangeRecord = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaRecord({
            ...tablaRecord,
            [e.target.name]: e.target.value
        })
    }
    const handleChangeReceta = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaReceta({
            ...tablaReceta,
            [e.target.name]: e.target.value
        })
    }

    const handleChange2 = (e) => {
        setTablaReceta({
            ...tablaReceta,
            ["medicamentoID"]: e.value, ["nombreMedicamento"]: e.nombre, ["pacienteiD"]: paciente.pacienteID, ["recordPacienteID"]: tablaRecord.recordPacienteGastroID
        })
    }


    const ValidarCedula = async (x) => {

        var nomb = Listado.filter(e => e.cedula == x).map(d => d);
        setTabla({
            ...tabla, nombrePaciente: "", cedula: x
        })
        if (nomb.length != 0) {
            var e = nomb[0].nombres + " EXISTE"
            MensajeG(e)
            setVerModal(!verModal);
            Setpaciente(nomb[0])
        }
        else {
            let response1 = await fetch(Api + "administracion/ConsultaCed/" + x);
            if (response1.ok) {
                let data1 = await response1.json()
                if (data1 != false) {
                    icono((data1[0]).sexo);
                    var ed = calcularEdad((data1[0]).fechaNacimiento, new Date()) 
                    setTabla({
                        ...tabla, nombrePaciente: (data1[0]).nombres+" "+ (data1[0]).apellido1 + " " + (data1[0]).apellido2, cedula: x,
                        edad: ed , sexo: (data1[0]).sexo, 
                    })
                } else {
                    setTabla({
                        ...tabla, nombrePaciente: "", cedula: x
                    })
                }
            }
        }
    }

    const MensajeG = (e) => toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",

    });

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Nutricion/ListaEvaluaciones");
        if (response.ok) {
            let data = await response.json()
            SetListado1(data);
            setPendiente(false)

            if (Inicio == false) {
                SetListado(data);
                SetInicio(true);
            }
        }
    }

    const obtenerDatosSeg = async () => {
        let response = await fetch(Api + "CMantenimiento/ListaSeguros/" + correo + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoSeg(data)
        }
    }

    const ObtenerRecord = async (e) => {
        let response = await fetch(Api + "Nutricion/ListaRecordPacienteNutricion/" + e + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoRecord(data)
        }
    }
    const ObtenerReceta = async (d) => {
        let response = await fetch(Api + "Nutricion/RecetasNutricion/" + d + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoReceta(data)
        }
    }
    const ObtenerMedicamento = async () => {
        let response = await fetch(Api + "Nutricion/MedicamentosNutricion");
        if (response.ok) {
            let data = await response.json()
            SetListaMedicamento(data)
            data.map(x => {
                options.push({
                    value: x.medicamentoID, label: x.descripcion, nombre: x.descripcion
                })
            })
        }
    }
    const ObtenerPruebas = async () => {
        let response = await fetch(Api + "Nutricion/ListaPruebas");
        if (response.ok) {
            let data = await response.json()
              data.map(x => {
                optionsP.push({
                    value: x.pruebaID, label: x.descripcion, nombre: x.descripcion
                })
            })
        }
    }


    useEffect(() => {
        obtenerDatos();
        obtenerDatosSeg();

    }, [])

    useEffect(() => {
        ObtenerMedicamento();
        obtenerDatosToxico();
      //  ObtenerPruebas()
    }, [])


    const abrirRecord = (data) => {
        Setpaciente(data);
        setTablap(data);
        ObtenerRecord(data.evaluacionID);
    }

    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {

            }
        })

    }


    const guardarCambios = async () => {
        let response;
        var editando = 0;
     
        if (tabla.evaluacionID == 0) {
        //    tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Nutricion/GuardarEvaluacion", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
          
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Nutricion/EditarEvaluaciones", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            editando = 1;
        }

            if (response.ok) {
            obtenerDatos();
            SetInicio(false);
                editando = 1
            let data1 = await response.json()
           // ObtenerRecord(data1.pacienteID)
            if (editando == 0) {
                Setpaciente(data1)
            }
            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }

            MensajeG("Guardado")

        } else {
            alert("error al guardar")
        }

    }
    const guardarCambiosRecord = async () => {
        let response;
        if (tablaRecord.recordPacienteNutricionID == 0) {
            tablaRecord.pacienteID = paciente.evaluacionID;
            response = await fetch(Api + "Nutricion/GuardarRecordPacienteNutricion", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaRecord)
            })

        } else {
            response = await fetch(Api + "Nutricion/EditarRecordPacienteNutricion", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaRecord)
            })
        }

        if (response.ok) {
            let data1 = await response.json()
            tablaRecord.recordPacienteGastroID = data1.recordPacienteGastroID
            tablaRecord.codigoUnico = data1.codigoUnico

            await ObtenerRecord();
            MensajeG("Guardado")
            // setTablaRecord(modeloRecord);
            SetReceta(true);

        } else {
            alert("error al guardar")
        }

    }
    const guardarCambiosReceta = async () => {
        let response;
        if (tablaReceta.recetaID == 0) {
            tablaRecord.pacienteID = paciente.pacienteID;
            response = await fetch(Api + "Nutricion2/GuardarRecetaNutricion", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaReceta)
            })
        } else {
            response = await fetch(Api + "Nutricion2/EditarRecetaNutricion", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaReceta)
            })
        }

        if (response.ok) {

            await ObtenerReceta(tablaRecord.recordPacienteGastroID);

            SetReceta(modeloReceta);
            MensajeG()
            // Setpaciente([]);

        } else {
            alert("error al guardar")
        }

    }
    const EliminarReceta = async (id) => {
        const response = fetch(Api + "Nutricion2/EliminarRecetaNutricion/" + id, { method: "DELETE" })
            .then(response => {
                if (response.ok) {
                    ObtenerReceta(tablaRecord.recordPacienteGastroID)
                }
            })
    }
    

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }
    const cerrarModalR = () => {
        setTablaRecord(modeloRecord)
        SetVerEmbarazada(false)
    }

    const columns = [

        {
            name: 'Pacientes ',
            selector: row => row.nombrePaciente,
            sortable: true,

        },
        {
            name: 'Telefono ',
            selector: row => row.telefono,
            sortable: true,

        }, {
            name: 'Edad ',
            selector: row => (row.edad),
            sortable: true,

        },

        {
            name: 'IMPORTANTE RECORDAR ',
            selector: row => (row.diagnosticoClinico),
            sortable: true,
            style: {
                color: "red"

            }
        },



        {
            name: '',

            cell: row => (
                <>
                    <Button class="btn" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirRecord(row)} 
                    >
                        <i className="fas fa-user-tag"></i>
                    </Button>
                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '12px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };
    const videoConstraints = {
        width: 20,
        height: 20,
        facingMode: "user"
    };
    const webcamRef = useRef(null);
    const capture = useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            SetCamara(false)

            tabla.imagen = imageSrc;
            document.getElementsByName("imagen").value = imageSrc;
        },
        [webcamRef]

    );
    const Atras = () => {
        Setpaciente([])
        SetEmbarazada(false)
    }
    const TerminarReceta = (d) => {
        if (d != '0') {
            window.open("/ImpresionReceta/" + d + "/ImpresionRecetaGinecologia.html" + "/Nutricion", '_blank');
        }

        obtenerDatos()
        Setpaciente([])
        setTablaReceta(modeloReceta)
        setTablaRecord(modeloRecord)
        SetReceta(false)

    }
    const icono = (d) => {
        const profileIcon = document.getElementById('profileIcon');
        if (d === 'F') {
            profileIcon.innerHTML = '👩';
        } else if (d === 'M') {
            profileIcon.innerHTML = '👨';
        } else {
            profileIcon.innerHTML = '👤';
        }
    };


    const obtenerDatosToxico = async () => {
        let response = await fetch(Api + "CMantenimiento/listaToxicos");
        if (response.ok) {
            let data = await response.json()
            SetListadoTox(data)

        }
    }

    function calcularEdad(Nacimiento, fechaActual) {
        var nacimiento = new Date(Nacimiento);
        var actual = new Date(fechaActual);

        var edad = actual.getFullYear() - nacimiento.getFullYear();
        var mes = actual.getMonth() - nacimiento.getMonth();
        var dia = actual.getDate() - nacimiento.getDate();

        // Ajustar si el mes o el día no ha pasado aún este año
        if (mes < 0 || (mes === 0 && dia < 0)) {
            edad--;
        }

        return edad;
    }

   
    function calcularSemanas(fechaInicio, fechaFin) {
        const unDia = 1000 * 60 * 60 * 24; // Milisegundos en un día
        const diferenciaDias = (fechaFin - fechaInicio) / unDia;
        return Math.floor(diferenciaDias / 7);
    }

   
    const VerRecord = (x) => {
        ObtenerReceta(x.recordPacienteGastroID)
        setTablaRecord(x);
        SetVerEmbarazada(true)
            
    }

    return (
        <>

            <ToastContainer />
            <div hidden={paciente.length == 0 } >


                <div class="containerR">

                    <div class="">

                        <h1>Consulta Médica</h1>
                    </div>
                    <div class="patient-info">
                        <div class="info-item">
                            <span class="info-label">Nombres y Apellidos:</span>
                            {paciente.nombrePaciente}
                        </div>
                         
                        <div class="info-item">
                            <span class="info-label">Edad:</span>

                            {paciente.edad}
                        </div>
                  
                        <div class="info-item">
                            <span class="info-label">Peso Inicio:</span>
                            {paciente.pesoInicio}
                        </div>

                        <div class="info-item">
                            <span class="info-label">Objetivo Principal:</span>
                         {paciente.objetivoPrincipal}
                       
                        </div>
                        <div class="info-item">
                            <span class="info-label">Alergia Alimentos:</span>
{paciente.alergiasAlimentos}
                         
                          
                        </div>

                        <div class="info-item">
                            <span class="info-label">Historial Familiar:</span>
                            {paciente.historialFamiliar}
                        </div>
                      
                    </div>

                

                    <div class="">
                        <div class="row">
                         
                            <div class="col-md-6">
                                <h4 class="mb-4"><b>Consulta</b></h4>

                                <form>
                                   <div class="row mb-3">
                               
                                        <div class="col-md-2">
                                            <label for="peso" class="form-label">Peso</label>
                                            <input type="text" class="form-control" id="peso" name="peso"
                                                value={tablaRecord.peso} onChange={handleChangeRecord} />
                                        </div>
                                        <div class="col-md-2">
                                            <label for="peso" class="form-label">Talla</label>
                                            <input type="text" class="form-control" id="talla" name="talla"
                                                value={tablaRecord.talla} onChange={handleChangeRecord} />
                                        </div>
                                        <div class="col-md-2">
                                            <label for="peso" class="form-label">IMC</label>
                                            <input type="text" class="form-control" id="imc" name="imc"
                                                value={tablaRecord.imc} onChange={handleChangeRecord} />
                                        </div>
                             
                                        <div class="col-md-2">
                                            <label for="presionAlterial" class="form-label">Ten Arte</label>
                                            <input type="text" class="form-control" id="tArterial" name="tArterial"
                                                value={tablaRecord.tArterial} onChange={handleChangeRecord} />
                                        </div>
                                      
                                        <div class="col-md-2">
                                            <label for="frecuenciaBebe" class="form-label">Fr. Card</label>
                                            <input type="text" class="form-control" id="fCardiaca" name="fCardiaca"
                                                value={tablaRecord.fCardiaca} onChange={handleChangeRecord} />
                                        </div>
                                   
                                    <div class="col-md-2">
                                            <label for="frecuenciaBebe" class="form-label">Frec. Resp.</label>
                                        <input type="text" class="form-control" id="fRespiratoria" name="fRespiratoria"
                                                value={tablaRecord.fRespiratoria} onChange={handleChangeRecord} />
                                        </div>
                                    </div>
                                  
                                 

                                    <div class="mb-3">
                                        <label for="historiaClinica" class="form-label">Historia Clínica</label>
                                        <textarea class="form-control" id="historiaClinica" name="historiaClinica" rows="3"
                                            onChange={handleChangeRecord} value={tablaRecord.historiaClinica}></textarea>
                                    </div>

                                    <div class="mb-3">
                                        <label for="comentario" class="form-label">Comentario</label>
                                        <textarea class="form-control" id="comentario" name="comentario" rows="3"
                                            onChange={handleChangeRecord} value={tablaRecord.comentario}></textarea>
                                    </div>

                                    <div class="d-flex justify-content-end">
                                        <button type="button" class="btn btn-danger me-2" onClick={Atras}>Cerrar</button>
                                        <button type="button" class="btn btn-primary" onClick={guardarCambiosRecord}
                                            disabled={!tablaRecord.historiaClinica}>Siguiente</button>
                                    </div>
                                </form>
                            </div>

                        
                            <div class="col-md-6">
                                <h4 class="mb-4"><b>Historial de consulta</b></h4>

                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Descripción</th>
                                            <th>Comentario</th>
                                            <th>Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ListadoRecord.map(x => (
                                            <tr key={x.codigoUnico}>
                                                <td>{moment(x.fecha).format("DD/MM/YY")}
                                                    <Button onClick={()=>VerRecord(x) } ><i className="fa fa-eye"></i></Button>
                                                </td>
                                                <td>
                                                    <textarea class="form-control" rows="2" value={x.historiaClinica} disabled></textarea>
                                                </td>
                                                <td>
                                                    <textarea class="form-control" rows="2" value={x.comentario} disabled></textarea>
                                                </td>
                                                <td>
                                                    <a class="btn btn-outline-secondary" target="_blank"
                                                        href={`/ImpresionReceta/${x.codigoUnico}/ImpresionRecetaGinecologia.html/Nutricion`}>
                                                        🖨️
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>






            <Col md="12" hidden={paciente.length != 0}>
                <Card>
                    <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                        <Row>
                            <Col md="8" >
                                <Input type="search" name="busqueda" onChange={(e) => onBusqueda(e)} placeholder="Busqueda de paciente " ></Input></Col>

                            <Col md="4" >

                                <Button color="success" size="md"
                                    onClick={() => setVerModal(!verModal)}
                                ><b>Nuevo Paciente</b></Button>
                                <Button color="warning" size="md"
                                //    href="/ReportesNutricion"
                                ><b>Reporte</b></Button>
                            </Col></Row>
                    </CardHeader>
                    <CardBody>

                        <DataTable
                            columns={columns}
                            data={Listado}
                            progressPending={pendiente}
                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            customStyles={customStyles}


                        />
                    </CardBody>
                </Card>
            </Col>


           

            <Modal className="modal-preguntas" isOpen={verModal}>

                <ModalBody>

                    {/*FORMULARIO*/}
                
                    <div class="containerp">
                        <div class="form-header">
                            <div class="box">
                                <div>Mantenimiento de Pacientes </div>
                                <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                            </div>

                            <div id="profileIcon" class="profile-icon">👤</div>
                        </div>
                            <form class="form-content">
                            <h5>Evaluación Nutricional de fecha: {moment(tabla.fecha).format("DD/MM/YYYY")}</h5>
                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="cedula">Cédula</label>
                                        <input type="text" id="cedula" name="cedula" onChange={handleChange} value={tabla.cedula} maxlength="11" required />
                                    </div>
                                </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="nombrePaciente">Nombre del paciente</label>
                                            <input type="text" id="nombrePaciente" name="nombrePaciente" value={tabla.nombrePaciente} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="edad">Edad</label>
                                            <input type="number" id="edad" name="edad" value={tabla.edad} onChange={handleChange} required />
                                        </div>
                                    </div>
                                   
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="sexo">Sexo</label>
                                        <select id="sexo" name="sexo" value={tabla.sexo} onChange={handleChange} >
                                            <option value="">Seleccione</option>
                                            <option value="F">Femenino</option>
                                            <option value="M">Masculino</option>
                                        </select>
                                    </div>
                                </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="ocupacion">Ocupación</label>
                                            <input type="text" id="ocupacion" name="ocupacion" value={tabla.ocupacion} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <h5>Hábitos Alimenticios</h5>
                                <div class="form-row">
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="comidasPrincipales">Comidas Principales por día</label>
                                            <input type="text" id="comidasPrincipales" name="comidasPrincipales" value={tabla.comidasPrincipales} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="refrigerios">Refrigerios por día</label>
                                            <input type="text" id="refrigerios" name="refrigerios" value={tabla.refrigerios} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="desayuno">Desayuno</label>
                                            <input type="text" id="desayuno" name="desayuno" value={tabla.desayuno} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="almuerzo">Almuerzo</label>
                                            <input type="text" id="almuerzo" name="almuerzo" value={tabla.almuerzo} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="cena">Cena</label>
                                            <input type="text" id="cena" name="cena" value={tabla.cena} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="bocadillos">Bocadillos</label>
                                            <input type="text" id="bocadillos" name="bocadillos" value={tabla.bocadillos} onChange={handleChange} />
                                        </div>
                                    </div>     <div class="form-col">
                                        <div class="form-group">
                                        <label for="bocadillos">Medico Tratante</label>
                                        <input type="text" id="medicoTratante" name="medicoTratante" value={tabla.medicoTratante} onChange={handleChange} />
                                        </div>
                                    </div>     <div class="form-col">
                                        <div class="form-group">
                                        <label for="bocadillos">Medicamentos</label>
                                        <input type="text" id="medicamentos" name="medicamentos" value={tabla.medicamentos} onChange={handleChange} />
                                        </div>
                                    </div>     <div class="form-col">
                                        <div class="form-group">
                                        <label for="bocadillos">Historial Familiar</label>
                                        <input type="text" id="historialFamiliar" name="historialFamiliar" value={tabla.historialFamiliar} onChange={handleChange} />
                                        </div>
                                    </div>     <div class="form-col">
                                        <div class="form-group">
                                        <label for="bocadillos">Peso Inicio LB</label>
                                        <input type="text" id="pesoInicio" name="pesoInicio" value={tabla.pesoInicio} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="aguaDiaria">Agua diaria</label>
                                            <input type="text" id="aguaDiaria" name="aguaDiaria" value={tabla.aguaDiaria} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="bebidas">Bebidas</label>
                                            <input type="text" id="bebidas" name="bebidas" value={tabla.bebidas} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="alcohol">Alcohol</label>
                                            <input type="text" id="alcohol" name="alcohol" value={tabla.alcohol} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="dietaEspecifica">Dieta específica</label>
                                            <input type="text" id="dietaEspecifica" name="dietaEspecifica" value={tabla.dietaEspecifica} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="alergiasAlimentos">Alergias alimentarias</label>
                                            <input type="text" id="alergiasAlimentos" name="alergiasAlimentos" value={tabla.alergiasAlimentos} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <h5>Objetivo Nutricional</h5>
                                <div class="form-row">
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="objetivoPrincipal">Objetivo Principal</label>
                                            <input type="text" id="objetivoPrincipal" name="objetivoPrincipal" value={tabla.objetivoPrincipal} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="actividadFisica">Actividad Física</label>
                                            <input type="text" id="actividadFisica" name="actividadFisica" value={tabla.actividadFisica} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="ejercicioRegular">Ejercicio Regular</label>
                                            <input type="text" id="ejercicioRegular" name="ejercicioRegular" value={tabla.ejercicioRegular} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <div class="btn-group">
                                    <button type="button" onClick={cerrarModal} class="btn btn-danger">Cerrar</button>
                                    <button type="submit" class="btn btn-primary" onClick={guardarCambios}>Guardar</button>
                                </div>
                            </form>
                        </div>
                </ModalBody>
                <ModalFooter>

                </ModalFooter>
            </Modal>

            <Modal isOpen={Camara}>
                <ModalHeader>
                    TOMAR FOTO
                </ModalHeader>
                <ModalBody>
                    <div >
                        <Webcam
                            audio={false}
                            height={400}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            width={400}
                            videoConstraints={videoConstraints}
                        />
                        <button onClick={capture}>Tomar Foto</button>

                    </div>
                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={() => SetCamara(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            <Modal isOpen={Receta} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Receta a Nombre de: {paciente.nombres + " " + paciente.apellidos}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => TerminarReceta(0)}>X</a></div>
                    </div>

                </ModalHeader>
                <ModalBody>
                    <Tabs >
                        <TabList>
                            <Tab>RECETA</Tab>
                            <Tab>ESTUDIO/EXAMEN</Tab>
                        </TabList>

                        <TabPanel>

                            <div >
                                <Row>
                                    <Col md="3">  <FormGroup>

                                        <Label>* Medicamento</Label>
                                        <Select
                                            name={"medicamentoID"}
                                            onChange={handleChange2}
                                            value={options.filter(x => x.value == tablaReceta.medicamentoID).map(x => x)}
                                            options={options}
                                        /></FormGroup></Col>


                                    <Col md="2">  <FormGroup > <Label for="exampleEmail">Dosificacion</Label>
                                        <Input type="text" name="dosificacion" value={tablaReceta.dosificacion} id="comentario"
                                            placeholder="dosificacion" onChange={handleChangeReceta} />

                                    </FormGroup>  </Col>
                                    <Col md="4">  <FormGroup > <Label for="exampleEmail">Comentario</Label>
                                        <Input type="text" name="comentario" value={tablaReceta.comentario} id="comentario"
                                            placeholder="Comentario" onChange={handleChangeReceta} />

                                    </FormGroup>  </Col>
                                    <Col md="2">
                                        <Button size="sm" color="primary"
                                            onClick={guardarCambiosReceta}
                                        >Agregar</Button></Col>

                                </Row>
                                <table>
                                    <tr>
                                        <th>Medicamento</th>
                                        <th>Dosificacion</th>
                                        <th>Comentario</th>
                                        <th>Quitar</th>
                                    </tr>
                                    {ListadoReceta.map(x => (
                                        <tr>
                                            <td>{x.nombreMedicamento}</td>
                                            <td>{x.dosificacion}</td>
                                            <td>{x.comentario}</td>
                                            <td> <Button size="sm" color="danger"
                                                onClick={() => EliminarReceta(x.codigoUnico)}
                                            >X</Button></td>
                                        </tr>
                                    ))}
                                </table>

                            </div>


                        </TabPanel>
                        <TabPanel>
                            <div >
                                <Row>
                                    <Col md="3">  <FormGroup>

                                        <Label>* Estudio</Label>
                                        <Select
                                            name={"PruebaID"}
                                            onChange={handleChange2}
                                            value={options.filter(x => x.value == tablaReceta.medicamentoID).map(x => x)}
                                            options={optionsP}
                                        /></FormGroup></Col>


                                    <Col md="4">  <FormGroup > <Label for="exampleEmail">Comentario</Label>
                                        <Input type="text" name="comentario" value={tablaReceta.comentario} id="comentario"
                                            placeholder="Comentario" onChange={handleChangeReceta} />

                                    </FormGroup>  </Col>
                                    <Col md="2">
                                        <Button size="sm" color="primary"
                                            onClick={guardarCambiosReceta}
                                        >Agregar</Button></Col>

                                </Row>
                                <table>
                                    <tr>
                                        <th>Examen / Estudio</th>
                                        <th>Categoria</th>
                                        <th>Comentario</th>
                                        <th>Quitar</th>
                                    </tr>
                                    {ListadoReceta.map(x => (
                                        <tr>
                                            <td>{x.nombreMedicamento}</td>
                                            <td>{x.dosificacion}</td>
                                            <td>{x.comentario}</td>
                                            <td> <Button size="sm" color="danger"
                                                onClick={() => EliminarReceta(x.codigoUnico)}
                                            >X</Button></td>
                                        </tr>
                                    ))}
                                </table>

                            </div>
                        </TabPanel>
                    </Tabs>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" size="sx" target="_blank"
                        onClick={() => TerminarReceta(tablaRecord.codigoUnico)}
                    ><i className="fa fa-print"></i></Button>
                    <Button size="sm" color="danger"
                        onClick={() => TerminarReceta(0)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

           
        </>
    )

}
export default Ginecologia;